/* Tech Sofa: crossfade hero, built on Swiper's fade effect (the agency standard for sliders).
   State lives on the element instance so duplicated sections never collide. */
if (!customElements.get('ts-hero-slider')) {
  customElements.define('ts-hero-slider', class TsHeroSlider extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('[data-hero-swiper]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (!this.container || !this.slides.length || this.ready) return;
      if (!window.Swiper) {
        window.addEventListener('load', () => this.connectedCallback(), { once: true });
        return;
      }
      this.ready = true;
      this.dots = Array.from(this.querySelectorAll('[data-go]'));
      this.count = this.querySelector('[data-count]');
      this.pauseBtn = this.querySelector('[data-hero-pause]');
      this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reduceMotion;
      this.userPaused = false;
      this.editing = false;
      if (this.pauseBtn && !this.autoplay) this.pauseBtn.hidden = true;

      const many = this.slides.length > 1;
      this.swiper = new Swiper(this.container, {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 800,
        rewind: many,
        allowTouchMove: many,
        autoplay: this.autoplay
          ? { delay: (parseFloat(this.dataset.interval) || 6) * 1000, disableOnInteraction: false }
          : false,
        a11y: { enabled: true, slideRole: 'group' },
        on: { slideChange: () => this.sync() },
      });

      this.addEventListener('click', (e) => {
        const pause = e.target.closest('[data-hero-pause]');
        if (pause) {
          this.userPaused = !this.userPaused;
          pause.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
          pause.setAttribute('aria-label', this.userPaused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
          if (this.userPaused) this.stop(); else this.start();
          return;
        }
        const go = e.target.closest('[data-go]');
        if (go) { this.swiper.slideTo(+go.dataset.go); return; }
        const nav = e.target.closest('[data-hero]');
        if (nav) { if (nav.dataset.hero === 'next') this.swiper.slideNext(); else this.swiper.slidePrev(); }
      });
      /* pause while the pointer or keyboard focus is anywhere in the hero, including its controls */
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      /* theme editor: jump to the slide being edited and hold it */
      this.addEventListener('shopify:block:select', (e) => {
        const n = this.slides.indexOf(e.target.closest('[data-slide]'));
        if (n > -1) { this.editing = true; this.stop(); this.swiper.slideTo(n); }
      });
      this.addEventListener('shopify:block:deselect', () => { this.editing = false; this.start(); });

      this.sync();
      this.loadTrustBoxes();
    }

    /* Trustpilot's bootstrap initialises TrustBoxes on page load; after a theme editor re-render they need a nudge. */
    loadTrustBoxes() {
      if (!window.Trustpilot || !window.Trustpilot.loadFromElement) return;
      this.querySelectorAll('.trustpilot-widget').forEach((el) => { if (!el.querySelector('iframe')) window.Trustpilot.loadFromElement(el, true); });
    }

    disconnectedCallback() {
      if (this.swiper) { this.swiper.destroy(true, true); this.swiper = null; }
      this.ready = false;
    }

    pad(n) { return (n < 10 ? '0' : '') + n; }

    sync() {
      if (!this.swiper || this.swiper.destroyed) return;
      const i = this.swiper.realIndex;
      this.slides.forEach((s, k) => {
        const on = k === i;
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      this.dots.forEach((d, k) => {
        d.classList.toggle('is-on', k === i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      if (this.count) this.count.textContent = this.pad(i + 1) + ' / ' + this.pad(this.slides.length);
    }

    start() {
      if (!this.autoplay || this.editing || this.userPaused || !this.swiper) return;
      this.swiper.autoplay.start();
    }

    stop() { if (this.autoplay && this.swiper) this.swiper.autoplay.stop(); }
  });
}
